import { Button, Link, Text } from '@factorialco/deprecated-design-system'
import { RevokeDatevLaudsTokenDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  companyId: number
  accessId: number
  clientId: string
  setShowDisconnectModal: (value: boolean) => void
  setAuthenticated: (value: boolean) => void
  setBannerCode: (value: number) => void
}

export const DisconnectModal = ({
  companyId,
  accessId,
  clientId,
  setShowDisconnectModal,
  setAuthenticated,
  setBannerCode,
}: Props) => {
  const [
    revokeIntegrationsdatevlaudsOauthToken,
    { loading: revokingIntegrationsdatevlaudsOauthToken },
  ] = useMutation(RevokeDatevLaudsTokenDocument, {
    extractorFn: (data) =>
      data.integrationsDatevLaudsMutations.revokeIntegrationsdatevlaudsOauthToken,
  })

  const revokeTokens = async () => {
    const result = await revokeIntegrationsdatevlaudsOauthToken({
      variables: {
        accessId: accessId,
        companyId: companyId,
        clientId: clientId,
      },
    })

    const handled = handleResult(result, (_errors) => {})
    if (handled.success) {
      setShowDisconnectModal(false)
      setAuthenticated(false)
      setBannerCode(0)
      window.location.reload()
    } else {
      app.setFlash({
        type: 'wrong',
        message: 'Error revoking tokens',
      })
    }
  }

  return (
    <Modal
      title={i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.offline_access_token.disconnect_modal_title'
      )}
      illustration="alert"
      onClose={() => setShowDisconnectModal(false)}
      footer={
        <>
          <Button type="secondary" onClick={() => setShowDisconnectModal(false)}>
            {i18n.t(
              'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.offline_access_token.cancel'
            )}
          </Button>
          <Button onClick={revokeTokens} disabled={revokingIntegrationsdatevlaudsOauthToken}>
            {i18n.t(
              'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.offline_access_token.disconnect'
            )}
          </Button>
        </>
      }
    >
      <>
        <Text size="300">
          {i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.offline_access_token.disconnect_modal_description'
          )}{' '}
          <Link.Href href={'https://apps.datev.de/tokrevui'}>here</Link.Href>.
        </Text>
      </>
    </Modal>
  )
}
